import { AppRoute } from '@app/core/routing/AppRoute';
import { RouteChildrenProps, Switch } from 'react-router-dom';
import { AdminFragmentsPage } from './manage/AdminFragmentsPage';

export function AdminFragmentsRoutes(props: RouteChildrenProps) {
  const { path } = props.match!;

  return (
    <Switch>
      <AppRoute path={`${path}`} component={AdminFragmentsPage} />
    </Switch>
  );
}
